import { moduleRegistry } from './module-registry';
// From the module file, not the feature's barrel: the barrel re-exports every
// cut sheet page and component, which would put all of them in the main bundle.
import { CutsheetsV2Module } from 'features/cutsheets/v2/module';
import { CapabilitiesV1Module } from 'features/capabilities/v1';
import { ReportingModule } from 'features/reporting/module';
import { PeerBenchmarksModule } from 'features/reporting/peer-benchmarks-module';
import { LandingPageModule } from 'features/landing-page/module';
import { DocumentsModule } from 'features/documents/module';
import { ChatModule } from 'pages/processor/chat/module';
import { NotificationsModule } from 'pages/processor/notifications/module';
import { ExportsModule } from 'pages/processor/exports/module';
import { WildGameModule } from 'pages/processor/wild-game/module';
import { IntegrationsModule } from 'pages/integrations/module';
import { InvoicesModule } from 'pages/invoices/module';
import { TeamManagementModule } from 'pages/processor/team/module';
import { InventoryModule } from 'pages/processor/inventory/module';
import { LocalDevicesModule } from 'pages/processor/local-devices/module';

/**
 * Initialize and register all application modules
 * This should be called once at application startup
 */
export function initializeModules(): void {
  console.log('[Modules] Initializing application modules...');

  // Register all feature modules here
  moduleRegistry.register(CutsheetsV2Module);
  moduleRegistry.register(CapabilitiesV1Module);
  moduleRegistry.register(ReportingModule);
  moduleRegistry.register(PeerBenchmarksModule);
  moduleRegistry.register(LandingPageModule);
  moduleRegistry.register(DocumentsModule);
  moduleRegistry.register(ChatModule);
  moduleRegistry.register(NotificationsModule);
  moduleRegistry.register(ExportsModule);
  moduleRegistry.register(WildGameModule);
  moduleRegistry.register(IntegrationsModule);
  moduleRegistry.register(InvoicesModule);
  moduleRegistry.register(TeamManagementModule);
  moduleRegistry.register(InventoryModule);
  moduleRegistry.register(LocalDevicesModule);

  console.log(
    `[Modules] Initialized ${moduleRegistry.getAll().length} modules`,
  );
}
